// extracted by mini-css-extract-plugin
export default {"keyboard":"Keyboard_keyboard__AUW3g","button":"Keyboard_button__tz+Bd"};